import { useState } from 'react';
import { styled } from '@mui/material/styles';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { getGenericTrackingData } from '@finanzcheck/one-segment';
import Image from 'next/image';

import Header from 'components/Header';
import PhoneBox from 'components/Header/PhoneBox';
import { MobileMenu } from 'components/HeaderNavigation/MobileMenu/MobileMenu';
import { DesktopMenu } from 'components/HeaderNavigation/DesktopMenu/DesktopMenu';

import { MobileMenuLink } from 'components/HeaderNavigation/MobileMenu/MobileMenuLink';
import { trackButtonClick } from 'lib/tracking/track';
import { TrackingEvent } from 'lib/tracking/events';

import menuItems from './MenuItems.json';

const StyledSeparator = styled('div')`
  background: rgb(211, 211, 211);
  height: 42px;
  width: 1px;
  margin: 0px 20px;
`;

const StyledLoginButton = styled(Link)`
  font-weight: 500;
  display: flex;
  align-items: center;
  & > svg {
    font-size: 12px;
    margin-left: 4px;
  }
`;

export const HeaderWithOptions = ({
  hasNavigationMenu = true,
  hasPhoneBox = true,
  hasLoginLink = true,
  hasTvLogos = false,
}) => {
  const [hasVisibleNavigation, setHasVisibleNavigation] = useState(false);

  const menuItemsWithoutLogin = menuItems.slice(1); // Remove the first item (Login) from the menu items

  const trackLogin = () => {
    trackButtonClick(TrackingEvent.LOGIN_LINK_ONINTERACT, {
      category: 'homepage',
      label: 'Jetzt anmelden',
      ...getGenericTrackingData(),
    });
  };
  return (
    <Header
      contentRight={
        <>
          {hasTvLogos && (
            <Box
              display={{ xs: 'none', md: 'flex' }}
              alignItems={{ md: 'center' }}
              aria-hidden={true}
            >
              <Image
                src="/assets/images/tv-logos.webp"
                width={440}
                height={24}
                quality={100}
                alt="Bekannt aus dem Fernsehen"
              />
            </Box>
          )}
          {hasPhoneBox && <PhoneBox />}
          {hasLoginLink && (
            <Box
              display={{ xs: 'none', sm: 'none', md: 'flex' }}
              alignItems={{ md: 'center' }}
            >
              <StyledSeparator />
              <StyledLoginButton
                underline="none"
                href="https://home.smava.de/login?"
                role="button"
                onClick={trackLogin}
                aria-label="Jetzt anmelden"
              >
                Jetzt anmelden
                <ArrowForwardIosIcon color="primary" aria-hidden={true} />
              </StyledLoginButton>
            </Box>
          )}
          {hasNavigationMenu && (
            <MobileMenuLink
              trackingEvent={TrackingEvent.MOBILE_HEADER_MENULINK_ONINTERACT}
              onClick={() => setHasVisibleNavigation(!hasVisibleNavigation)}
            >
              Menü
            </MobileMenuLink>
          )}
        </>
      }
      contentBottom={
        <>
          {hasNavigationMenu && (
            <>
              <MobileMenu
                visible={hasVisibleNavigation}
                aria-visible={hasVisibleNavigation}
                onClose={() => setHasVisibleNavigation(false)}
                hasLoginLink={hasLoginLink}
                aria-role="menu"
                menuItems={menuItemsWithoutLogin}
              />

              <DesktopMenu menuItems={menuItemsWithoutLogin} />
            </>
          )}
        </>
      }
    />
  );
};
